(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af-footer"] && !Shopify.designMode) return;
  try {
    
  /* AF footer — Klaviyo signup via the Client API (custom form, no widget).
     Falls back to Klaviyo's hosted subscribe page when JS is unavailable. */
  (() => {
    for (const form of document.querySelectorAll('[data-af-klaviyo]')) {
      if (form.dataset.afBound) continue;
      form.dataset.afBound = '1';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const status = form.querySelector('[data-af-status]');
        const email = form.querySelector('[data-af-email]')?.value.trim();
        const firstName = form.querySelector('[data-af-first-name]')?.value.trim();
        const button = form.querySelector('button[type="submit"]');
        if (!email) return;

        const say = (text, isError) => {
          if (!status) return;
          status.hidden = false;
          status.textContent = text;
          status.classList.toggle('af-footer__status--error', Boolean(isError));
        };

        button?.setAttribute('aria-busy', 'true');

        const attributes = { email: email };
        if (firstName) attributes.first_name = firstName;

        try {
          const response = await fetch(
            'https://a.klaviyo.com/client/subscriptions/?company_id=' +
              encodeURIComponent(form.dataset.afKlaviyoKey),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                revision: '2024-10-15',
              },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    profile: { data: { type: 'profile', attributes: attributes } },
                  },
                  relationships: {
                    list: { data: { type: 'list', id: form.dataset.afKlaviyoList } },
                  },
                },
              }),
            }
          );

          if (response.ok || response.status === 202) {
            say(form.dataset.afSuccess, false);
            form.querySelectorAll('input:not([type="hidden"])').forEach((i) => (i.value = ''));
          } else {
            say(form.dataset.afError, true);
          }
        } catch (e) {
          say(form.dataset.afError, true);
        } finally {
          button?.removeAttribute('aria-busy');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af-friends-list"] && !Shopify.designMode) return;
  try {
    
  /* AF Friends list — filled-state flag for the birthday menus (v1.5). CSS has
     no :placeholder-shown for a <select>, so mark them here. Runs regardless of
     the Filled-fields setting; the class only paints when that is set to solid. */
  (() => {
    for (const sel of document.querySelectorAll('.af-fl__select')) {
      if (sel.dataset.afFillBound) continue;
      sel.dataset.afFillBound = '1';
      const sync = () => sel.classList.toggle('af-fl__select--filled', Boolean(sel.value));
      sync();
      sel.addEventListener('change', sync);
    }
  })();

  /* AF Friends list — SHOPIFY path (v1.4). The customer form has no birthday
     field, so on submit the day/month are appended to contact[tags] as
     <prefix>MM-DD. Shopify accepts a comma-separated tag list, and the
     Shopify->Klaviyo sync carries tags across, so the date survives the
     loyalty-friendly route. JS off = the base tag posts on its own and the
     signup still works. */
  (() => {
    for (const tags of document.querySelectorAll('[data-af-shop-tags]')) {
      const form = tags.closest('form');
      if (!form || form.dataset.afShopBound) continue;
      form.dataset.afShopBound = '1';
      const base = tags.value;

      form.addEventListener('submit', () => {
        const day = form.querySelector('[data-af-bday-day]')?.value;
        const month = form.querySelector('[data-af-bday-month]')?.value;
        if (!day || !month) {
          tags.value = base;
          return;
        }
        const pad = (n) => String(n).padStart(2, '0');
        const prefix = tags.dataset.afBdayPrefix || 'bday-';
        tags.value = `${base},${prefix}${pad(month)}-${pad(day)}`;
      });
    }
  })();

  /* AF Friends list — KLAVIYO path: signup via the Client API (custom form,
     no widget), mirroring af-footer. Birthday rides along as a profile
     property in YYYY-MM-DD so a Date-property flow can repeat yearly. */
  (() => {
    for (const form of document.querySelectorAll('[data-af-klaviyo]')) {
      if (form.dataset.afBound) continue;
      form.dataset.afBound = '1';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const status = form.querySelector('[data-af-status]');
        const email = form.querySelector('[data-af-email]')?.value.trim();
        const firstName = form.querySelector('[data-af-first-name]')?.value.trim();
        const day = form.querySelector('[data-af-bday-day]')?.value;
        const month = form.querySelector('[data-af-bday-month]')?.value;
        const yearInput = form.querySelector('[data-af-bday-year-input]')?.value;
        const button = form.querySelector('button[type="submit"]');
        if (!email) return;

        const say = (text, isError) => {
          if (!status) return;
          status.hidden = false;
          status.textContent = text;
          status.classList.toggle('af-fl__status--error', Boolean(isError));
          status.classList.toggle('af-fl__status--success', !isError);
        };

        button?.setAttribute('aria-busy', 'true');

        const attributes = { email: email };
        if (firstName) attributes.first_name = firstName;

        /* Both parts required for a valid date; the year falls back to the
           placeholder dial so a day+month answer still stores cleanly. */
        if (day && month) {
          const year = yearInput || form.dataset.afBdayYear || '1900';
          const pad = (n) => String(n).padStart(2, '0');
          attributes.properties = {
            [form.dataset.afBdayProp || 'Birthday']: `${year}-${pad(month)}-${pad(day)}`,
          };
        }

        try {
          const response = await fetch(
            'https://a.klaviyo.com/client/subscriptions/?company_id=' +
              encodeURIComponent(form.dataset.afKlaviyoKey),
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                revision: '2024-10-15',
              },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    profile: { data: { type: 'profile', attributes: attributes } },
                  },
                  relationships: {
                    list: { data: { type: 'list', id: form.dataset.afKlaviyoList } },
                  },
                },
              }),
            }
          );

          if (response.ok || response.status === 202) {
            say(form.dataset.afSuccess, false);
            form.querySelectorAll('input:not([type="hidden"])').forEach((i) => (i.value = ''));
            form.querySelectorAll('select').forEach((s) => (s.selectedIndex = 0));
          } else {
            say(form.dataset.afError, true);
          }
        } catch (e) {
          say(form.dataset.afError, true);
        } finally {
          button?.removeAttribute('aria-busy');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af-help-center"] && !Shopify.designMode) return;
  try {
    
  /* Pane switcher. Delegated at the document so it survives theme-editor
     section reloads without rebinding. */
  (function () {
    function panes(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-af-help-pane]'));
    }
    function tabs(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-af-help-tab]'));
    }

    function show(root, id, push) {
      var found = false;
      panes(root).forEach(function (p) {
        var on = p.id === id;
        p.hidden = !on;
        if (on) found = true;
      });
      if (!found) return false;
      tabs(root).forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-current', on);
        if (on) a.setAttribute('aria-current', 'page');
        else a.removeAttribute('aria-current');
      });
      var sel = root.querySelector('[data-af-help-select]');
      if (sel) sel.value = '#' + id;
      if (push && window.history && history.replaceState) {
        /* replaceState, not a hash assignment — setting location.hash would
           jump the page to the pane and undo the rail's sticky position. */
        history.replaceState(null, '', '#' + id);
      }
      /* An embed that first measured itself while its pane was hidden reads a
         width of 0. Nudge anything listening once it is visible. */
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
      return true;
    }

    function init(root) {
      if (root.dataset.afHelpReady) return;
      root.dataset.afHelpReady = '1';
      var hash = (window.location.hash || '').replace('#', '');
      if (!hash || !show(root, hash, false)) {
        var first = panes(root)[0];
        if (first) show(root, first.id, false);
      }
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-af-help-tab]') : null;
      if (!a) return;
      var root = a.closest('[data-af-help]');
      if (!root) return;
      var id = (a.getAttribute('href') || '').replace('#', '');
      if (id && show(root, id, true)) e.preventDefault();
    });

    document.addEventListener('change', function (e) {
      var sel = e.target;
      if (!sel || !sel.matches || !sel.matches('[data-af-help-select]')) return;
      var v = sel.value || '';
      var root = sel.closest('[data-af-help]');
      if (v.charAt(0) === '#' && root) {
        if (show(root, v.replace('#', ''), true)) return;
      }
      /* a Link entry — leave the page */
      if (v) window.location.href = v;
    });

    window.addEventListener('hashchange', function () {
      var id = (window.location.hash || '').replace('#', '');
      if (!id) return;
      document.querySelectorAll('[data-af-help]').forEach(function (r) {
        show(r, id, false);
      });
    });

    function boot() {
      document.querySelectorAll('[data-af-help]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af-image-collection"] && !Shopify.designMode) return;
  try {
    
  /* AF image + collection — mobile carousel chevrons. Pure scroll-snap
     underneath (swipe always works); the pair scrolls one card and greys
     out at the ends. Re-binds on shopify:section:load for the editor. */
  (() => {
    const bindAll = () => {
      document.querySelectorAll('.af-ic-section').forEach((root) => {
        if (root.dataset.afIcBound) return;
        const track = root.querySelector('[data-af-ic-track].af-ic__grid--m-carousel');
        const prev = root.querySelector('[data-af-ic-prev]');
        const next = root.querySelector('[data-af-ic-next]');
        if (!track || (!prev && !next)) return;
        root.dataset.afIcBound = '1';

        const step = () => {
          const cards = track.querySelectorAll('.af-ic__card');
          if (cards.length < 2) return track.clientWidth;
          return cards[1].offsetLeft - cards[0].offsetLeft;
        };
        const maxScroll = () => track.scrollWidth - track.clientWidth;

        const mark = (btn, end) => {
          if (!btn) return;
          btn.classList.toggle('is-end', end);
          btn.toggleAttribute('disabled', end);
        };

        const sync = () => {
          mark(prev, track.scrollLeft <= 2);
          mark(next, track.scrollLeft >= maxScroll() - 2);
        };

        prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

        let raf = null;
        track.addEventListener(
          'scroll',
          () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
              raf = null;
              sync();
            });
          },
          { passive: true }
        );
        window.addEventListener('resize', sync);
        sync();
      });
    };

    bindAll();
    document.addEventListener('shopify:section:load', () => bindAll());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af-product-showcase"] && !Shopify.designMode) return;
  try {
    
  /* AF product showcase — carousel navigation (arrows / clickable dots).
     Pure scroll-snap underneath, so swipe and trackpad always work too.
     Re-binds on shopify:section:load so arrows keep working in the theme
     editor after a settings change re-renders the section. */
  (() => {
    const bindAll = () => {
    const sections = document.querySelectorAll('.af-ps-section');
    for (const root of sections) {
      if (root.dataset.afPsBound) continue;
      const track = root.querySelector('[data-af-ps-track].af-ps__grid--carousel, [data-af-ps-track].af-ps__grid--hybrid');
      if (!track) continue;
      root.dataset.afPsBound = '1';

      const cards = () => [...track.querySelectorAll('.af-ps__card')];
      const step = () => {
        const list = cards();
        if (list.length < 2) return track.clientWidth;
        return list[1].offsetLeft - list[0].offsetLeft;
      };
      const maxScroll = () => track.scrollWidth - track.clientWidth;

      const prev = root.querySelector('[data-af-ps-prev]');
      const next = root.querySelector('[data-af-ps-next]');
      const dotsWrap = root.querySelector('[data-af-ps-dots]');
      let dots = [];

      const pages = () => Math.max(1, Math.round(maxScroll() / step()) + 1);

      const buildDots = () => {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        dots = [];
        const count = pages();
        if (count < 2) return;
        for (let i = 0; i < count; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'af-ps__dot';
          dot.setAttribute('aria-label', 'Go to position ' + (i + 1));
          dot.addEventListener('click', () => {
            track.scrollTo({ left: Math.min(i * step(), maxScroll()), behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        }
      };

      /* An exhausted direction greys out (stays visible) — both at once
         when everything already fits. */
      const setArrow = (btn, off) => {
        if (!btn) return;
        btn.classList.toggle('is-end', off);
        btn.toggleAttribute('disabled', off);
      };

      const sync = () => {
        const index = Math.min(Math.round(track.scrollLeft / step()), dots.length - 1);
        dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
        setArrow(prev, track.scrollLeft <= 2);
        setArrow(next, track.scrollLeft >= maxScroll() - 2);
      };

      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

      let raf = null;
      track.addEventListener(
        'scroll',
        () => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = null;
            sync();
          });
        },
        { passive: true }
      );
      window.addEventListener('resize', () => {
        buildDots();
        sync();
      });

      buildDots();
      sync();
    }
    };

    bindAll();
    document.addEventListener('shopify:section:load', () => bindAll());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
